export default [
  {
    title: "Invite Users",
    icon: "UserIcon",
    route: "users-subscribed",
    resource: "Invoice",
    action: "manage",
  },
];
